module.exports = __webpack_public_path__ + "img/pgn01.0cca3810.png";